import React from "react";
import "./Category.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import Api from "../../Common/api.jsx";
import SkeletonProduct from "../../Pages/Skeleton/index.jsx";


export default class Category extends React.Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.state = {
      loader: false,
      collections: [],
      totalRecords: 0,
      pageNumber: 1,
      pageSize: 20,
      account: null,
      categoryName: "Art",
      categoryDetails: null,
    };
  }
  async componentDidMount() {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    this.setState({ categoryName: params.get("name") }, () => {
      this.getCategory();
    });
  }

  getCategory() {
    this.setState({loader:true});
  
    new Api()
      .get("get_category/?name=" + this.state.categoryName)
      .then((response) => {
        this.setState({ categoryDetails: response.data }, () => {
          this.getCollections();
        });
        this.setState({loader: false});
      });
  }

  getCollections() {
    const api = new Api();
    const obj = {
      pagenumber: this.state.pageNumber,
      pagesize: this.state.pageSize,
      categoryid: this.state.categoryDetails.id,
    };

    api
      .post("get_category_collections/", obj)
      .then((response) => {
        this.setState({
          collections: [
            ...this.state.collections,
            ...response.data.collections,
          ],
          totalRecords: response.data.totalRecords,
        });
      })
      .catch((err) => console.log(err));
  }

  loadMoreCollections(event) {
    event.preventDefault();

    var totalRecords = this.state.totalRecords;
    var totalPages = Math.ceil(totalRecords / this.state.pageSize);
    if (this.state.pageNumber > totalPages) return;

    this.setState({ pageNumber: this.state.pageNumber + 1 }, () => {
      this.getCollections();
    });
  }

  toggleMoreButton() {
    var totalRecords = this.state.totalRecords;
    var totalPages = Math.ceil(totalRecords / this.state.pageSize);
    return this.state.pageNumber < totalPages;
  }

  render = () => {
    return (
      <>
        <Header />
        <div>
          <div className="container">
            <section className="user-board">
              <div className="user-board__data-banner">
                <img
                  className="user-board__imgbanner"
                  src={this.state.categoryDetails?.banner_image}
                  alt=""
                />
              </div>
              <div className="user-board__data margin-top">
                <div className="user-board__data-ttl">
                  <span>Explore {this.state.categoryName}</span>
                </div>
                <div className="user-board__data-score">
                  <p className="para">
                    {this.state.categoryDetails?.description}
                  </p>
                </div>
              </div>
            </section>
            <div className="filter-list-box-wrap">
            {!this.state.loader ? (
              <ul className="explore-nfts">
                {this.state.collections.map((explores, index) => (
                  <li key={index}>
                    <a
                      href={
                        "../CollectionDetails/?collectionId=" +
                        explores.collection_id
                      }
                      className="card"
                    >
                      <div className="card-img">
                        <img
                          src={
                            explores.collection_image
                              ? explores.collection_image
                              : "../images/card1.png"
                          }
                          alt="discover"
                        />
                      </div>
                      <div className="card-body">
                        <div className="artist-block">
                          <div className="media">
                            <div className="media-img">
                              <img
                                src={
                                  explores.user_profile_image
                                    ? explores.user_profile_image
                                    : "../images/default_image.png"
                                }
                                alt="artist block"
                              />
                            </div>
                            <div className="media-body">
                              <span>{explores.collection_name}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
               ) :  [1, 2, 3, 4,5,6,7,8,9,10,11,12].map(loading =>(
                <>
                  <div className="skeleton-items" key={loading}>
                  <SkeletonProduct />
                  </div>
                </>
              ))}
            </div>
            <div className="button-wrap">
              {this.toggleMoreButton() ? (
                <button
                  onClick={(event) => this.loadMoreCollections(event)}
                  className="button purple-outline"
                >
                  Show More
                </button>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  };
}
